/** Components shared by the three branch relationship tabs. */

export function ErrorBanner({ message, onDismiss }: { message: string; onDismiss?: () => void }) {
  return (
    <div role="alert" className="mt-3 flex items-start gap-3 rounded border border-red/40 bg-red/5 px-3 py-2 text-sm text-red">
      <span className="flex-1">{message}</span>
      {onDismiss && (
        <button type="button" onClick={onDismiss} className="text-xs font-semibold hover:underline">
          Dismiss
        </button>
      )}
    </div>
  );
}

export function FieldError({ message }: { message?: string }) {
  return <span className="mt-1 block text-xs font-normal text-red">{message}</span>;
}
